export const INPUT_WRAPPER_MARGIN_TOP = 12

export const SCROLL_INITIAL_WAIT_TIME = 750
export const SCROLL_OFFSET = 128
